<ng-container [ngSwitch]="layout$ | async">
  <app-default-category-page *ngSwitchCase="layouts.Default" [slug]="slug"></app-default-category-page>
  <app-fresh-category-page *ngSwitchCase="layouts.Fresh" [slug]="slug"></app-fresh-category-page>
</ng-container>
